import React from 'react'
import { useTranslation } from 'react-i18next'
import { Widget } from 'features/types'
import { HTMLWidget as HTMLWidgetType } from 'schemas/HTMLWidgetSchema'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import ErrorMessage from 'components/share/ErrorMessage'

const NOT_SUPPORTED_PATHS = ['/cb/nb/', '/cb/live/', '/cb/web/live-report/', '/cb/web/']

// MW-32486: Patch script protocol to use https
const patchScriptProtocol = (code: string) =>
  code.replace(new RegExp('(src\\s*=\\s*[\'"])\\/\\/(.*?\\.js.*?[\'"])', 'g'), '$1https://$2')

const HTMLWidget: Widget = ({ widgetId }) => {
  const widgetSetting = useDashboardWidgetSetting<HTMLWidgetType>(widgetId)
  const { text = '' } = widgetSetting
  const { t } = useTranslation()
  const { origin, pathname } = window.location
  const notSupportedTextRegex = new RegExp(
    NOT_SUPPORTED_PATHS.map((path) => `${origin}${path}`).join('|')
  )

  const iframeElements = new DOMParser()
    .parseFromString(text, 'text/html')
    .getElementsByTagName('iframe')
  const anchorElements = new DOMParser()
    .parseFromString(text, 'text/html')
    .getElementsByTagName('a')

  const iframeSrc = Array.from(iframeElements).map((iframeElement) => iframeElement.src)
  const anchorHref = Array.from(anchorElements)
    .filter((anchorElement) => anchorElement.target === '' || anchorElement.target === '_self')
    .map((anchorElement) => anchorElement.href)

  const urls = [...iframeSrc, ...anchorHref].map((url) =>
    // handle both relative and absolute URLs
    new URL(url, `${origin}${pathname}`).toString()
  )

  for (let i = 0; i < urls.length; i += 1) {
    if (notSupportedTextRegex.test(urls[i])) {
      return <ErrorMessage>{t('htmlOjectIsNotSupported')}</ErrorMessage>
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    <iframe
      className="html-widget-iframe"
      style={{
        width: '100%',
        height: '100%',
        border: '0',
        overflow: 'auto'
      }}
      srcDoc={patchScriptProtocol(text)}
    />
  )
}

export default HTMLWidget
